
import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsDoNotDisturb from './components/Settings/SettingsDoNotDisturb'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  saveDoNotDisturb, updateDoNotDisturb
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsDoNotDisturbContainer extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("Do Not Disturb"))
    if (!this.props.settings.do_not_disturb_start) {
      this.props.dispatch(updateDoNotDisturb({do_not_disturb_start: "21:00"}, false))
    }
    if (!this.props.settings.do_not_disturb_end) {
      this.props.dispatch(updateDoNotDisturb({do_not_disturb_end: "08:00"}, false))
    }
  }

  handleSubmit(cb) {
    this.props.dispatch(saveDoNotDisturb(this.props.settings.do_not_disturb_enabled, this.props.settings.do_not_disturb_start, this.props.settings.do_not_disturb_end))
      .then(() => cb())
  }

  render() {
    const shouldDisableSubmit = !this.props.settings.do_not_disturb_dirty || (this.props.settings.do_not_disturb_start === this.props.settings.do_not_disturb_end)

    return <SettingsStep shouldDisableSubmit={shouldDisableSubmit} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsDoNotDisturb {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsDoNotDisturbContainer)
